
export default {
  install(Vue, options) {
    Vue.prototype.verifyData = function () {
      return {
        userid: sessionStorage.getItem('verifyData_userid'),
        username: sessionStorage.getItem('verifyData_username'),
        cid: sessionStorage.getItem('verifyData_cid'),
        token: sessionStorage.getItem('verifyData_token'),
        time: sessionStorage.getItem('verifyData_time'),
        loginType: sessionStorage.getItem('verifyData_loginType'),
      };
    }
    Vue.prototype.vhttp = function (vdata) {
      var funThen = {}
      var funCatch = {}
      var config = vdata
      config.url = vdata.url
      var varifyData = {
        userid: sessionStorage.getItem('verifyData_userid'),
        username: sessionStorage.getItem('verifyData_username'),
        cid: sessionStorage.getItem('verifyData_cid'),
        token: sessionStorage.getItem('verifyData_token'),
        time: sessionStorage.getItem('verifyData_time'),
        loginType: sessionStorage.getItem('verifyData_loginType'),
      }
      funThen = vdata.funThen === undefined ? function () {
      } : vdata.funThen
      funCatch = vdata.funCatch === undefined ? function () {
      } : vdata.funCatch
      if (config.data !== undefined) {
        config.method = 'post'
      }
      config.data = {verifyData: varifyData, body: config.data}
      var selfVue = this
      this.axios_(config)
        .then(function (response) {
          if (typeof response.data !== 'string') {
            if (response.data.code == 401 || response.data.code === undefined) {
              // 校验失败跳转到登录界面
              sessionStorage.setItem('verifyData_userid', 0)
              let type = sessionStorage.getItem('loginType')
              if (type == 1) {
                location.hash = '/admin'
              } else if (type == 2) {
                location.hash = '/login'
              }
              return
            }
            funThen(response)
          }
          //console.log(response.data)
        })
        .catch(function (error) {
          funCatch(error)
        })
    }
    Vue.prototype.reSetData = function (data) {
      let item = data.filter(t => t.pid == 0)

      function loop(item) {
        for (let i in item) {
          item[i].children = data.filter(t => t.pid == item[i].id)
          loop(item[i].children)
        }
      }

      loop(item)
      return item
    }
    Vue.prototype.sort_ = function (tarrFrom, key, type = 0) {
      let tarr = tarrFrom
      for (let i = 0; i < tarr.length; i++) {
        for (let v = 0; v < tarr.length; v++) {
          let tmove = false
          if (type === 0 && tarr[i][key] * 1 < tarr[v][key] * 1) tmove = true
          if (type === 1 && tarr[i][key] * 1 > tarr[v][key] * 1) tmove = true
          if (tmove === true) {
            let tr = tarr[v]
            tarr[v] = tarr[i]
            tarr[i] = tr
          }
        }
      }
      return tarr
    }
    Vue.prototype.numberToChinese = function (num) {
      const numStr = num.toString().trim().replace(/,/g, ''); // 关键：移除所有逗号
      num = Number(numStr);
      if (isNaN(num)) return '无效数字';
      if (num < 0) return '不支持负数';
      if (num === 0) return '零元整';

      // 后续代码保持不变...
      const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const unit = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'];
      const decimalUnit = ['角', '分'];

      const [integerPart, decimalPart = '00'] = num.toFixed(2).split('.');
      let chinese = '';

      // 4. 处理整数部分
      if (integerPart !== '0') {
        // 遍历整数每一位
        for (let i = 0; i < integerPart.length; i++) {
          const n = parseInt(integerPart[i]);
          const pos = integerPart.length - 1 - i; // 位数位置（个位=0，十位=1...）

          // 非零数字：拼接数字+单位
          if (n !== 0) {
            chinese += digit[n] + unit[pos];
          }
          // 零数字：仅当前后非零、且未连续加零时拼接零
          else {
            if (i > 0 && integerPart[i - 1] !== '0' && pos % 4 !== 0) {
              chinese += digit[0];
            }
          }

          // 处理万/亿单位（避免重复）
          if (pos === 4 && chinese.slice(-1) !== '万') {
            chinese += '万';
          }
          if (pos === 8 && chinese.slice(-1) !== '亿') {
            chinese += '亿';
          }
        }
        chinese += '元'; // 整数部分结尾加“元”
      }

      // 5. 处理小数部分（角、分）
      const jiao = parseInt(decimalPart[0]);
      const fen = parseInt(decimalPart[1]);

      if (jiao === 0 && fen === 0) {
        chinese += '整'; // 无小数则加“整”
      } else {
        if (jiao !== 0) chinese += digit[jiao] + decimalUnit[0];
        if (fen !== 0) {
          // 角为零但分为非零时，补“零”
          if (jiao === 0) chinese += '零';
          chinese += digit[fen] + decimalUnit[1];
        }
      }

      // 6. 清理冗余（如“零万”“零亿”）
      chinese = chinese.replace(/零([万|亿])/g, '$1').replace(/零+/g, '零');
      // 结尾零清理（如“壹元零整”→“壹元整”）
      chinese = chinese.replace(/零整$/, '整').replace(/零$/, '');

      return chinese;
    }
  }
}



// WEBPACK FOOTER //
// ./src/base/base.vue